export enum UserRole {
    Admin = 'admin',
    StaffUser = 'staff_user',
    DeActivatedUser = 'deactivated_user',
    UnverifiedUser = 'unverified_user',
    User = 'user',
}
